// extracted by mini-css-extract-plugin
export var chip = "_5d-9";
export var chipLabel = "_5d-a";
export var close = "_5d-7";
export var closeIcon = "_5d-8";
export var error = "_5d-6";
export var infoTooltip = "_5d-2";
export var innerContainer = "_5d-1";
export var input = "_5d-b";
export var medium = "_5d-5";
export var outerContainer = "_5d-0";
export var small = "_5d-4";
export var xSmall = "_5d-3";